import { render, staticRenderFns } from "./ProcessPathList.vue?vue&type=template&id=4c61b129"
import script from "./ProcessPathList.vue?vue&type=script&lang=js"
export * from "./ProcessPathList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports